import { Card } from './Card.js';
import clsx from 'clsx';

interface KPITileProps {
  label: string;
  waarde: string | number;
  icon?: React.ReactNode;
  trend?: { value: number; label: string };
  accentKleur?: string;
  onClick?: () => void;
}

export function KPITile({ label, waarde, icon, trend, accentKleur = 'var(--brand-primary)', onClick }: KPITileProps) {
  return (
    <Card
      className={clsx('relative overflow-hidden', onClick && 'cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all')}
      onClick={onClick}
    >
      <div className="absolute top-0 left-0 right-0 h-1" style={{ backgroundColor: accentKleur }} />
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-gray-500 mb-1">{label}</p>
          <p className="text-2xl font-bold text-gray-900">{waarde}</p>
          {trend && (
            <p className={clsx('text-xs mt-1', trend.value >= 0 ? 'text-status-green' : 'text-status-red')}>
              {trend.value >= 0 ? '↑' : '↓'} {Math.abs(trend.value)}% {trend.label}
            </p>
          )}
        </div>
        {icon && (
          <div className="p-2 rounded-lg bg-gray-50 text-gray-400">
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
}
